module.exports = __webpack_public_path__ + "img/05fe602.png";